import React, { useEffect } from "react";
import FooterPageLayout from "src/layouts/footer-page";

export default function EndUserLicenseAgreement() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <FooterPageLayout title="End User License Agreement">
        <style>{`
          footer {
          position: relative;
          width: 100%;
          padding: 0;
          margin:0;
          z-index: 1;
          background:#fff;
          border:none;
        }
        footer div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #e3dedb;
          font-size: 12px;
          margin:0 auto;
          padding: 10px 0;
          list-style:none;
        }
        footer div a {
          margin: 0;
        }
          footer div a:hover {
          text-decoration: none;
          color: #9b928b;
        }
        footer div a:after {
          content: '|';
          padding: 0 8px;
        }

        footer div a:last-child:after {
          content: none;
          padding: 0;
        }
            `}</style>
            <div
                name="termly-embed"
                data-id="d4d08c86-78b2-4177-9c9d-814f749ab906"
                data-type="iframe"
            ></div>
        </FooterPageLayout>
    );
}
